// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';

import { css } from '@emotion/css';

import { useTimeline } from '@components/Timeline/Timeline/TimelineProvider';

import TimelineAreaHeader from '@components/Timeline/Timeline/TimelineAreaHeader';
import TimelineAreaBody from '@components/Timeline/Timeline/TimelineAreaBody';

// COMPONENT ---------------------------------------------------------------- //

const TimelineArea = () => {
  const cls = useStyles();

  const { zIndex } = useTimeline();

  return (
    <div className={cls.timelineArea} style={{ zIndex: zIndex }}>
      <TimelineAreaHeader />
      <TimelineAreaBody />
    </div>
  );
};

// STYLES --------------------------------------------------------------------- //

const useStyles = () => ({
  timelineArea: css`
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1;
    width: max-content;
    min-height: 100%;
  `,
});

// -------------------------------- EXPORT -------------------------------- //

export default TimelineArea;
